import {gql} from 'graphql-tag';
import {baseResponseGraphqlField} from '../../../base.graphql';

export const contactUsFields = `
         id
        uniqueId
        contact
`;

export const GET_CONTACT_US = gql`
  query GetContactUs {
    getContactUs {
      ${baseResponseGraphqlField}
      data {
        ${contactUsFields}
      }
    }
  }
`;

